import { createFileRoute } from "@tanstack/react-router";
import AdminLayout from "../pages/admin/Layout";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});
